import { render, staticRenderFns } from "./code-show.vue?vue&type=template&id=0fb0b557&scoped=true&"
import script from "./code-show.vue?vue&type=script&lang=js&"
export * from "./code-show.vue?vue&type=script&lang=js&"
import style0 from "./code-show.vue?vue&type=style&index=0&id=0fb0b557&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb0b557",
  null
  
)

export default component.exports